import { useSettingsContext } from '@eversports/react-app-base/SettingsContext'

import Footer from '../../components/Footer'
import Header from '../../components/Header'
import MetaHelmet from '../../components/MetaHelmet'
import Search from '../../components/Search'
import getStaticPageMetadata from '../../helpers/get-static-page-metadata'
import { useIntl } from '../../localization/react'

import Forbidden from './Forbidden'

const ForbiddenScreen = () => {
  const intl = useIntl()
  const { origin } = useSettingsContext()

  const meta = getStaticPageMetadata({
    title: intl.forbiddenPageTitle(),
    description: intl.forbiddenPageDescription(),
    url: origin,
  })

  return (
    <>
      <MetaHelmet meta={meta} noIndex />
      <Header position={{ xs: 'relative', lg: 'sticky' }}>
        <Search />
      </Header>
      <Forbidden />
      <Footer />
    </>
  )
}

export default ForbiddenScreen
